module.exports = "<div class=\"panel panel-info\">\r\n    <div class=\"panel-body\">\r\n        {{'modules.editors.nothing.description' | translate}}\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/widgets/empty/empty.widget.html
// module id = ./src/app/views/presentations/widgets/empty/empty.widget.html
// module chunks = main